import React from 'react';

import { useTable, useGlobalFilter, useSortBy, usePagination } from 'react-table';

import GlobalFilter from './GlobalFilter';
import Pagination from './Pagination';
import ColumnHeader from './ColumnHeader';
import RowHeader from './RowHeader';

const AnalysisTable = ({ columns, data, goToJournal, resultsPerPage }) => {
  const options = { columns, data, initialState: { pageSize: resultsPerPage } };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    state,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    pageCount,
    state: { pageIndex, pageSize }
  } = useTable(options, useGlobalFilter, useSortBy, usePagination);

  const pagination =
    data.length > resultsPerPage ? (
      <Pagination
        {...{
          pageSize,
          pageIndex,
          pageCount,
          canPreviousPage,
          canNextPage,
          gotoPage,
          previousPage,
          nextPage
        }}
      />
    ) : (
      <div className="Explorer-Journals-Pagination-Container"></div>
    );

  return (
    <div>
      <GlobalFilter
        placeholder="e.g. Physics Letters, arXiv, figshare"
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      />

      {pagination}

      <table {...getTableProps()}>
        <caption className="visually-hidden">{I18n.t('Explorer.Journals.table_caption')}</caption>
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key, role } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} role={role}>
                {headerGroup.headers.map((column) => (
                  <ColumnHeader key={column.Header} column={column} />
                ))}
              </tr>
            );
          })}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            const [rowHeader, ...values] = row.cells;
            const { key, role } = row.getRowProps();
            const { headerKey, headerRole } = rowHeader.getCellProps();

            return (
              <tr key={key} role={role}>
                <RowHeader
                  key={headerKey}
                  role={headerRole}
                  value={rowHeader.render('Cell')}
                  onClick={() => goToJournal(rowHeader.row.original.source.id)}
                  mentioned_research_outputs={row.original.mentioned_research_outputs}
                />
                {values.map((cell) => {
                  const { key, role } = cell.getCellProps();
                  return (
                    <td key={key} role={role}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {pagination}
    </div>
  );
};

export default AnalysisTable;
